import * as React from 'react';

export default function PlusBlack({
  className,
  viewBox = '0 0 20 20',
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.9999 2.39844C8.44173 2.39844 8.7999 2.75661 8.7999 3.19844V7.19844H12.7999C13.2417 7.19844 13.5999 7.55661 13.5999 7.99844C13.5999 8.44027 13.2417 8.79844 12.7999 8.79844H8.7999V12.7984C8.7999 13.2403 8.44173 13.5984 7.9999 13.5984C7.55807 13.5984 7.1999 13.2403 7.1999 12.7984V8.79844H3.1999C2.75807 8.79844 2.3999 8.44027 2.3999 7.99844C2.3999 7.55661 2.75807 7.19844 3.1999 7.19844H7.1999V3.19844C7.1999 2.75661 7.55807 2.39844 7.9999 2.39844Z"
        fill="#4E4D54"
      />
    </svg>
  );
}
